import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { Card } from '../../CommonComponents/OPL/Card/Card';

export const StyledMarkdown = styled(Markdown)(({ theme }) => ({
  fontFamily: theme.fontFamily,
  fontSize: theme.fontSizes.body,
  lineHeight: theme.lineHeights.body,
  color: theme.colors.neutral['700'],

  p: {
    marginTop: 0,
    marginBottom: 8,
    '&:last-child': { marginBottom: 0 },
  },

  'ul, ol': {
    marginTop: 4,
    marginBottom: 8,
    paddingLeft: 24,
  },

  li: {
    marginBottom: 4,
  },

  strong: {
    fontWeight: 600,
    color: theme.colors.neutral['900'],
  },
}));

export const PeopleCardsRow = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  gap: theme.space['12'],
  marginBottom: theme.space['16'],
}));

export const StatsRow = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.space['16'],
  flexWrap: 'wrap' as const,
}));

const categoryColorMap: Record<string, string> = {
  protection: '#3182CE',
  retirement: '#2B6CB0',
  income: '#38A169',
  tax: '#805AD5',
  estate: '#8B6914',
  savings: '#2F855A',
  debt: '#E53E3E',
  education: '#D69E2E',
  general: '#718096',
};

export const InsightCard = styled(Card)<{ category?: string }>(({ theme, category }) => ({
  borderLeft: `4px solid ${categoryColorMap[category || 'general'] || categoryColorMap.general}`,
  marginBottom: theme.space['8'],
}));

InsightCard.defaultProps = {
  ...Card.defaultProps,
  hasBorder: true,
  p: '12',
};

export const WarningCard = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.space['8'],
  backgroundColor: theme.colors.warning['50'],
  border: `1px solid ${theme.colors.warning['200']}`,
  borderRadius: theme.radii.medium,
  padding: theme.space['12'],
  marginBottom: theme.space['8'],
}));

export const SectionHeader = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.space['12'],
}));

export const WarningsToggle = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.space['8'],
  cursor: 'pointer',
  userSelect: 'none' as const,
  marginTop: theme.space['16'],
}));
